import React from 'react';

import useRestrictionsComboSystem from './useRestrictionsComboSystem';

interface Props {
    betslipBetId: string;
}

const RestrictionsComboSystem: React.FC<Props> = ({ betslipBetId }) => {
    useRestrictionsComboSystem({ betslipBetId });

    return null;
};

export default React.memo(RestrictionsComboSystem);
